import React from 'react'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash'
import { checkIdtfFeatureEnabled } from 'configs'
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import TextAreaInput from '../../containers/Forms/components/TextAreaInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import {
  emailMask,
  phoneNumberMask,
  getDateOfBirthMask,
  requiredValidation,
  dateValidation,
  emailValidation,
  phoneValidation,
  minLen1Validation,
  notesLenValidation,
  notJustSpacesValidation,
  validateMedantaUHIDCheck,
} from '../../containers/Forms/components/formValidations'
import { getName } from '../../containers/Utilities'
import RadioButton from '../../containers/Forms/components/RadioButton'
import { UNASSIGNED_ORDERING_PHYSICIAN_OPTION, FORM_SEX_OPTIONS, getDateOfBirthFormat, PATIENT_FIELD_NAMES } from '../../constants'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../components/Loading'
import { filterIsPhysicianPermission } from '../../store/appReducer'
import { IMPLANTED_DEVICES } from './constants'


const NewPatientForm = props => {
  const {
    handleSubmit,
    physicians,
    invalid,
    pristine,
    submitting,
    isSubmitting,
    medantaUHIDValidation,
    me,
  } = props

  const getFieldConfig = fieldName => {
    return (
      me &&
      me.data &&
      me.data.teams[0] &&
      me.data.teams[0].teamPatientFields &&
      me.data.teams[0].teamPatientFields.filter(
        item => item.fieldName === fieldName,
      )
    )
  }
  const isFieldVisible = fieldConfig => {
    return !!fieldConfig && fieldConfig.length > 0 && fieldConfig[0].isVisible
  }
  const firstNameMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'firstName')
  const lastNameMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'lastName')
  const custom_participant_idMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'customParticipantID')
  const emailMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'email')
  const sexMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'sex')
  const date_of_birthMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'dob')
  const ordering_physician_member_idMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'orderingPhysicianMemberID')
  const phone_numberMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'phone')
  const notesMe = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields && me.data.teams[0].teamPatientFields.filter(item => item.fieldName === 'notes')
  const studyIdConfig = getFieldConfig(PATIENT_FIELD_NAMES.STUDY_ID)
  const subjectIDConfig = getFieldConfig(PATIENT_FIELD_NAMES.SUBJECT_ID)
  const siteIdentificationNumberConfig = getFieldConfig(PATIENT_FIELD_NAMES.SITE_IDENTIFICATION_NUMBER)
  const isStudyIdvisible = isFieldVisible(studyIdConfig)
  const isSubjectIdVisible = isFieldVisible(subjectIDConfig)
  const isSiteIdentificationVisible = isFieldVisible(siteIdentificationNumberConfig)

  const canShowStudyIdSection = isStudyIdvisible || isSubjectIdVisible || isSiteIdentificationVisible

  const customFields = _.sortBy(me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.isCustom === true && item.isVisible),
    [ o => o.displayName && o.displayName.toLowerCase() ])

  // get IDTF feature is enabled status
  const isIdtfEnabled = checkIdtfFeatureEnabled(me)

  let physicianOptions = [ UNASSIGNED_ORDERING_PHYSICIAN_OPTION ]

  if (physicians && physicians.data) {
    physicianOptions = [
      ...physicianOptions,
      ...filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id])),
    ]
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        { /* studyid, subject id and site identification section [KPW-2484] */}
        {
          (canShowStudyIdSection) &&
          <div className={styles.formSection}>
            <div className={styles.formSectionRow}>
              {
                isSubjectIdVisible ?
                  <Field
                    component={TextInput}
                    label="Patient ID" // was - subjectIDConfig[0].displayName, changed as KPW-3106
                    name={PATIENT_FIELD_NAMES.SUBJECT_ID}
                    required={subjectIDConfig[0].isRequired}
                    validate={subjectIDConfig[0].isRequired ? requiredValidation : null}
                  />
                  :
                  <div className={styles.editLabelGroup}>
                    <div className={styles.editPlaceholder} />
                    {/* Empty Space */}
                  </div>
              }
              { isStudyIdvisible ?
                <Field
                  component={TextInput}
                  label={studyIdConfig[0].displayName}
                  name={PATIENT_FIELD_NAMES.STUDY_ID}
                  required={studyIdConfig[0].isRequired}
                  validate={studyIdConfig[0].isRequired ? requiredValidation : null}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
              { isSiteIdentificationVisible ?
                <Field
                  component={TextInput}
                  label={siteIdentificationNumberConfig[0].displayName}
                  name={PATIENT_FIELD_NAMES.SITE_IDENTIFICATION_NUMBER}
                  required={siteIdentificationNumberConfig[0].isRequired}
                  validate={siteIdentificationNumberConfig[0].isRequired ? requiredValidation : null}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
            </div>
          </div>
        }
        {/* first name and last name section */}
        {
          ((firstNameMe && firstNameMe.length > 0 && firstNameMe[0].isVisible) || (lastNameMe && lastNameMe.length > 0 && lastNameMe[0].isVisible)) &&
          <div className={styles.formSection}>
            <div className={styles.formSectionRow}>
              {
                firstNameMe && firstNameMe.length > 0 && firstNameMe[0].isVisible ?
                  <Field
                    component={TextInput}
                    label={firstNameMe[0].displayName}
                    name="firstName"
                    required={firstNameMe[0].isRequired}
                    validate={firstNameMe[0].isRequired ? requiredValidation : null}
                    // required={isIdtfEnabled}
                    // validate={isIdtfEnabled ? requiredValidation : null}
                  />
                  :
                  <div className={styles.editLabelGroup}>
                    <div className={styles.editPlaceholder} />
                    {/* Empty Space */}
                  </div>
              }
              {lastNameMe && lastNameMe.length > 0 && lastNameMe[0].isVisible ?
                <Field
                  component={TextInput}
                  label={lastNameMe[0].displayName}
                  name="lastName"
                  required={lastNameMe[0].isRequired}
                  validate={lastNameMe[0].isRequired ? requiredValidation : null}
                  // required={isIdtfEnabled}
                  // validate={isIdtfEnabled ? requiredValidation : null}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
              <div className={styles.placeholder} />
            </div>
          </div>
        }
        {/* other default field section */}
        {
          ((custom_participant_idMe && custom_participant_idMe.length > 0 && custom_participant_idMe[0].isVisible) || (emailMe && emailMe.length > 0 && emailMe[0].isVisible) ||
          (sexMe && sexMe.length > 0 && sexMe[0].isVisible) || (date_of_birthMe && date_of_birthMe.length > 0 && date_of_birthMe[0].isVisible) || (ordering_physician_member_idMe && ordering_physician_member_idMe.length > 0 && ordering_physician_member_idMe[0].isVisible) ||
          (phone_numberMe && phone_numberMe.length > 0 && phone_numberMe[0].isVisible)) &&
          <div className={styles.formSection}>
            <div className={styles.formSectionRow}>
              {custom_participant_idMe && custom_participant_idMe.length > 0 && custom_participant_idMe[0].isVisible ?
                <Field
                  component={TextInput}
                  label={custom_participant_idMe[0].displayName}
                  name="customParticipantID"
                  // required={true}
                  // validate={[ requiredValidation, notJustSpacesValidation, validateMedantaUHIDCheck ]}
                  required={custom_participant_idMe[0].isRequired}
                  validate={custom_participant_idMe[0].isRequired ? [ requiredValidation, notJustSpacesValidation, validateMedantaUHIDCheck ] : notJustSpacesValidation}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
              { emailMe && emailMe.length > 0 && emailMe[0].isVisible ?
                <Field
                  component={MaskedInput}
                  mask={emailMask}
                  placeholder="name@example.com"
                  label={emailMe[0].displayName}
                  name="email"
                  required={emailMe[0].isRequired}
                  validate={emailMe[0].isRequired ? [ emailValidation, minLen1Validation, requiredValidation ] : [ emailValidation, minLen1Validation ]}
                // required={!isIdtfEnabled}
                // validate={isIdtfEnabled ? [ emailValidation, minLen1Validation ] : [ emailValidation, minLen1Validation, requiredValidation ]}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
              {sexMe && sexMe.length > 0 && sexMe[0].isVisible ?
                <Field
                  component={ReactSelectDropdownInput}
                  label={sexMe[0].displayName}
                  name="sex"
                  placeholder="Select a sex"
                  options={FORM_SEX_OPTIONS}
                  required={sexMe[0].isRequired}
                  noOptionsMessage="No Sex found"
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.id}
                  validate={sexMe[0].isRequired ? requiredValidation : null}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }
            </div>
            <div className={styles.formSectionRow}>
              {date_of_birthMe && date_of_birthMe.length > 0 && date_of_birthMe[0].isVisible ?
                <Field
                  component={MaskedInput}
                  mask={getDateOfBirthMask(me)}
                  placeholder={getDateOfBirthFormat(me)}
                  label={date_of_birthMe[0].displayName}
                  name="dob"
                  validate={date_of_birthMe[0].isRequired ? [ dateValidation, requiredValidation ] : dateValidation}
                  required={date_of_birthMe[0].isRequired}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }

              {ordering_physician_member_idMe && ordering_physician_member_idMe.length > 0 && ordering_physician_member_idMe[0].isVisible ?
                <Field
                  component={ReactSelectDropdownInput}
                  label={ordering_physician_member_idMe[0].displayName}
                  name="orderingPhysician"
                  isLoading={physicians && physicians.isFetching}
                  isClearable={false}
                  backspaceRemovesValue={false}
                  placeholder="Unassigned"
                  options={physicianOptions}
                  noOptionsMessage="No provider found"
                  getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                  getOptionValue={p => p.id}
                  required={ordering_physician_member_idMe[0].isRequired}
                  validate={ordering_physician_member_idMe[0].isRequired ? requiredValidation : null}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }

              {phone_numberMe && phone_numberMe.length > 0 && phone_numberMe[0].isVisible ?
                <Field
                  component={MaskedInput}
                  mask={phoneNumberMask}
                  placeholder="XXX XXX-XXXX"
                  label={phone_numberMe[0].displayName}
                  name="phone"
                  // required={isIdtfEnabled}
                  // validate={isIdtfEnabled ? [ phoneValidation, requiredValidation ] : phoneValidation}
                  required={phone_numberMe[0].isRequired}
                  validate={phone_numberMe[0].isRequired ? [ phoneValidation, requiredValidation ] : phoneValidation}
                />
                :
                <div className={styles.editLabelGroup}>
                  <div className={styles.editPlaceholder} />
                  {/* Empty Space */}
                </div>
              }

            </div>
          </div>

        }

        {/* Implanted Devices field only if IDTF feature is enabled */}
        {/* {isIdtfEnabled &&
        <div className={styles.formSection}>
          <Field
            required
            component={RadioButton}
            label="Implanted Devices"
            name="implantedDevice"
            options={IMPLANTED_DEVICES}
            props={{ value: IMPLANTED_DEVICES }}
            validate={requiredValidation}
          />
        </div>
        } */}
        {
          (customFields && customFields.length > 0) && (
            <React.Fragment>
              <h2 className={styles.formTitle}>Custom Field</h2>
              <div className={styles.formSection}>
                <div style={{ display: 'block' }} className={styles.formSectionRow}>
                  {customFields.map((item, i) => (
                    item.isCustom && item.isVisible &&
                    <div style={i !== 0 ? { marginTop: 10 } : {}} key={item.id}>
                      <Field
                        component={TextInput}
                        label={item.displayName}
                        name={item.fieldName}
                        required={item.isRequired}
                        validate={item.isRequired ? requiredValidation : null}
                      />
                    </div>
                  ))}
                  <div className={styles.placeholder} />
                </div>
              </div>
            </React.Fragment>
          )
        }

        {/* notes section */}
        {
          notesMe && notesMe.length > 0 && notesMe[0].isVisible &&
          <div className={styles.formSection}>
            { notesMe && notesMe.length > 0 && notesMe[0].isVisible ?
              <Field
                component={TextAreaInput}
                label={notesMe[0].displayName}
                name="notes"
                required={notesMe[0].isRequired}
                validate={notesMe[0].isRequired ? [ notesLenValidation, requiredValidation ] : notesLenValidation}
              // validate={[ notesLenValidation, requiredValidation ]}
              />
              :
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
                {/* Empty Space */}
              </div>
            }
          </div>
        }

        <div className={styles.submitWrapper}>
          <div className={styles.buttonWrapper}>
            {submitting || isSubmitting ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              <button type="submit" disabled={invalid || pristine} className={styles.submit}>
                <SaveIcon />
              Save
              </button>
            }
          </div>
        </div>
      </form>
    </div>
  )
}

export default reduxForm({
  form: 'newPatientForm',
})(NewPatientForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/NewPatientForm.jsx